import { Loader2, ShieldCheck, ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const AdminLogin = ({ username, password, onUsername, onPassword, error, loading, onSubmit }) => (
  <div className="min-h-screen bg-secondary/40 flex items-center justify-center p-4" data-testid="admin-login">
    <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 shadow-sm">
      <div className="text-center mb-7">
        <div className="mx-auto mb-4 h-14 w-14 rounded-2xl bg-accent text-primary flex items-center justify-center"><ShieldCheck className="h-7 w-7" /></div>
        <img src="/netlen-logo.svg" alt="Netlen" className="h-7 w-auto mx-auto mb-3 dark:invert" onError={(e) => { e.target.style.display = 'none'; }} />
        <h1 className="text-2xl font-semibold">Yönetim paneli</h1>
        <p className="text-sm text-muted-foreground mt-1">Devam etmek için yönetici hesabınızla giriş yapın.</p>
      </div>
      {error && <div className="mb-5 rounded-lg border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive text-center" role="alert" data-testid="admin-login-error">{error}</div>}
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2"><Label htmlFor="admin-username">Kullanıcı adı</Label>
          <Input id="admin-username" value={username} onChange={(e) => onUsername(e.target.value)} className="h-11" placeholder="admin" autoComplete="username" required data-testid="admin-username" /></div>
        <div className="space-y-2"><Label htmlFor="admin-password">Şifre</Label>
          <Input id="admin-password" type="password" value={password} onChange={(e) => onPassword(e.target.value)} className="h-11" placeholder="••••••••" autoComplete="current-password" required data-testid="admin-password" /></div>
        <Button type="submit" disabled={loading} className="w-full h-11" data-testid="admin-login-submit">{loading ? <Loader2 className="h-5 w-5 animate-spin" /> : 'Giriş yap'}</Button>
      </form>
      <a href="/" className="mt-6 flex items-center justify-center gap-2 text-sm text-muted-foreground hover:text-foreground"><ArrowLeft className="h-4 w-4" />Ana sayfaya dön</a>
    </div>
  </div>
);

export default AdminLogin;
